import jwtDecode from 'jwt-decode';
import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';
import { firebaseConfig } from 'src/config';

const initialState = {
  isLoading: false,
  error: false,
  isCreated: false,
  tasks: [],
  task: null
};

const slice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.isCreated = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload.error;
      state.isCreated = false;
    },
    getTasksSuccess(state, action) {
      state.isLoading = false;
      state.tasks = action.payload.tasks;
      state.isCreated = false;
    },
    getTaskSuccess(state, action) {
      state.isLoading = false;
      state.task = action.payload.task;
      state.isCreated = false;
    },
    addTaskSuccess(state, action) {
      state.isLoading = false;
      state.task = action.payload.task;
      state.isCreated = true;
    },
    /*sortByTasks(state, action) {
      state.sortBy = action.payload;
    },
    filterTasks(state, action) {
      state.filters.category = action.payload.category;
      state.filters.priceRange = action.payload.priceRange;
      state.filters.rating = action.payload.rating;
    },*/
    deleteTask(state, action) {}
    //createBilling(state, action) {},
    //applyDiscount(state, action) {},
    //applyShipping(state, action) {}
  }
});

export default slice.reducer;

export const {
  startLoading,
  hasError,
  getTasksSuccess,
  getTaskSuccess,
  deleteTask
  //sortByTasks,
  // filterTasks,
  //createBilling,
  //applyDiscount,
  //applyShipping
} = slice.actions;

export function getTasks() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `${firebaseConfig.measurementId}/api/Task`
      );
      const tasks = response.data;
      dispatch(slice.actions.getTasksSuccess({ tasks }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMyTasks(userId) {
  return async (dispatch) => {
    dispatch(slice.action.startLoading());
    try {
      const response = await axios.post(
        `${firebaseConfig.measurementId}/api/Task`,
        JSON.stringify({
          userId: userId
        })
      );
      const tasks = response.data;
      dispatch(slice.actions.getTasksSuccess({ tasks }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTask(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('api/tasks', {
        params: { id }
      });
      const { task } = response.data;
      dispatch(slice.actions.getTaskSuccess({ task }));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addTask(task) {
  return async (dispatch) => {
    const response = await axios.post(
      `${firebaseConfig.measurementId}/api/Task/Add`,
      JSON.stringify({
        identifier: task.identifier,
        description: task.description,
        deadLineDate: task.deadLineDate,
        idUserCreator: task.idUserCreator,
        habilities: task.habilities,
        documents: ['id1', 'id2']
      }),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    dispatch(slice.actions.addTaskSuccess(response.data));
  };
}
